/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, SimpleGrid } from "@chakra-ui/react";
import DevelopmentTable from "views/admin/assetTables/components/DevelopmentTable";
import CheckTable from "views/admin/assetTables/components/CheckTable";
import ColumnsTable from "views/admin/assetTables/components/ColumnsTable";
import ComplexTable from "views/admin/assetTables/components/ComplexTable";
import AssetTable from "views/admin/assetTables/components/AssetTable";
import {
  columnsDataDevelopment,
  columnsDataCheck,
  columnsDataColumns,
  columnsDataComplex,
  columnsAssetTable,
} from "views/admin/assetTables/variables/columnsData";
import tableDataDevelopment from "views/admin/assetTables/variables/tableDataDevelopment.json";
import tableDataCheck from "views/admin/assetTables/variables/tableDataCheck.json";
import tableDataColumns from "views/admin/assetTables/variables/tableDataColumns.json";
import tableDataComplex from "views/admin/assetTables/variables/tableDataComplex.json";
// import tableAssets from "views/admin/assetTables/variables/tableAssets.json";
import React, { useEffect, useState } from "react";
import axios from 'axios';

export default function Settings() {
  // Chakra Color Mode  
  const [assetData, setAssetData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const uri = process.env.REACT_APP_AWS_FLASK_BASE_URI + "/assets";
    console.log(uri);
    const data = {
      "api_key": process.env.REACT_APP_AWS_FLASK_API_KEY
    }
    axios.post(uri, data)
      .then(response => {
        console.log("Fetched Data: ", response.data); // Log fetched data
        setAssetData(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("There was an error fetching the CVE data - Settings page!", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data: {error.message}</p>;


  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb='20px'
        columns={{ sm: 1, md: 2 }}
        spacing={{ base: "20px", xl: "20px" }}>
      </SimpleGrid>      
      <AssetTable columnsData={columnsAssetTable} tableData={assetData} />
    </Box>
  );
}
